var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03418 21.8936C5.71527 21.8936 4.78715 21.6494 4.24982 21.1609C3.76133 20.6236 3.51709 19.6955 3.51709 18.3765V14.0535C3.51709 11.3668 3.81018 9.07091 4.39636 7.16582C5.03139 5.26072 5.88624 3.45333 6.96091 1.74363L10.9909 2.98927C10.6001 4.45472 10.3315 5.87133 10.1849 7.23909C10.0872 8.60684 10.0384 10.0723 10.0384 11.6355C11.9435 11.6355 12.896 12.6613 12.896 14.7129L12.8227 18.3765C12.7739 19.6955 12.4808 20.6236 11.9435 21.1609C11.4061 21.6494 10.5024 21.8936 9.23236 21.8936H7.03418ZM19.9302 21.8936C18.6113 21.8936 17.6832 21.6494 17.1458 21.1609C16.6573 20.6236 16.4131 19.6955 16.4131 18.3765V14.0535C16.4131 11.3668 16.7062 9.07091 17.2924 7.16582C17.9274 5.26072 18.7822 3.45333 19.8569 1.74363L23.8869 2.98927C23.4961 4.45472 23.2275 5.87133 23.0809 7.23909C22.9832 8.60684 22.9344 10.0723 22.9344 11.6355C24.8395 11.6355 25.792 12.6613 25.792 14.7129L25.7187 18.3765C25.6699 19.6955 25.3768 20.6236 24.8395 21.1609C24.3021 21.6494 23.3984 21.8936 22.1284 21.8936H19.9302Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 8.48086e-8,
    y1: -18.3158,
    x2: 33.59,
    y2: -16.1307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5748"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuot);
export default __webpack_public_path__ + "static/media/quot.ac4bf9fa05aceb5c72c8af6f3ae16b33.svg";
export { ForwardRef as ReactComponent };